import * as PropTypes from "prop-types";
import {connect} from 'react-redux'
import {Component} from "react";
import * as React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowRight} from "@fortawesome/free-solid-svg-icons";
import {ORDER_ROUTES} from "../const/routes";
import {Link} from "react-router-dom";
import './OrderStepRow.scss';
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Řádek zobrazující jednotlivé kroky procesu objednávky.
 */
class OrderStepRow extends Component<WithTranslation> {

    static propTypes = {
        currentStep: PropTypes.number, // číslo kroku, který je právě aktivní (bude zvýrazněn)
        lastStep: PropTypes.number, // číslo posledního kroku pro který již máme data (byl již vyplněn)
    };

    renderOrderStep = (step, index) => {
        const {currentStep, lastStep, t} = this.props;
        const finished = lastStep ? (index <= lastStep) : ((index + 1) < currentStep);
        const active = (index + 1) === currentStep;
        let content = <span>
                <div className="order-step-number">{index + 1}</div>
                <span className="order-step-title">{t(step.key)}</span>
            {!step.final && <FontAwesomeIcon icon={faArrowRight}/>}
        </span>;
        if (finished) {
            content = <Link to={step.path}>{content}</Link>
        }
        return <span key={index} className={`order-step${active ? " active" : finished ? " finished" : ""}`}>
            {content}
        </span>
    };

    render() {
        return <div className="order-step-row">
            {ORDER_ROUTES.map(this.renderOrderStep)}
        </div>
    }
}

export default connect()(withTranslation()(OrderStepRow));
